import { useCallback, useState } from "react";
import { ConsumoQueryParams } from "core/features/consumo/typings";
import moment from "moment";

function useFiltroConsumo() {
  const [filtro, setFiltro] = useState<ConsumoQueryParams>({
    page: 1,
    limit: 20,
    search: "",
    mes: moment().format("YYYY-MM"),
  });

  const onChangeFiltro = useCallback((_filtro: Partial<ConsumoQueryParams>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroConsumo;
